import {Action} from "@ngrx/store";
import {HostingDomainData} from '../../websites/website/hosting/domains/hostingDomainData';

export const LOAD_DOMAINS: string = '[domain] Load Domains';
export const LOAD_DOMAINS_SUCCESS: string = '[domain] Load Domains Success';
export const LOAD_DOMAINS_FAIL: string = '[domain] Load Domains Fail';

export const LOAD_ZONES: string = '[domain] Load Zones';
export const LOAD_ZONES_SUCCESS: string = '[domain] Load Zones Success';
export const LOAD_ZONES_FAIL: string = '[domain] Load Zones Fail';

export class LoadDomains implements Action {
  readonly type: string = LOAD_DOMAINS;
  constructor(public payload: {
    websiteId: number,
    childWebsiteId?: number
  }) {}
}

export class LoadDomainsSuccess implements Action {

  readonly type: string = LOAD_DOMAINS_SUCCESS;
  constructor(public payload: {
    websiteId: number,
    childWebsiteId?: number,
    domainEntities: {[domainId: number]: HostingDomainData}
  }) {}

}

export class LoadDomainsFail implements Action {

  readonly type: string = LOAD_DOMAINS_FAIL;
  constructor(public payload: string) {}

}

export class LoadZones implements Action {

  readonly type: string = LOAD_ZONES;

}

export class LoadZonesSuccess implements Action {

  readonly type: string = LOAD_ZONES_SUCCESS;
  constructor(public payload: {
    zoneEntities: any
  }) {}

}

export class LoadZonesFail implements Action {

  readonly type: string = LOAD_ZONES_FAIL;
  constructor(public payload: string) {}

}


export type DomainAction = LoadDomains | LoadDomainsSuccess | LoadDomainsFail
  | LoadZones | LoadZonesSuccess | LoadZonesFail;
